import appConstants from '../constants';
import fetchService from './fetchService';

const SERVICE_URL = `${appConstants.SERVICE_BASE_URL}${appConstants.SERVICE_REQUEST_GET_USER_SAVED_PARTNERS_URL}`;

function processData(data) {
  if(!!data && ('object' === typeof data)) {
    if(data?.favPartnerList !== undefined && Array.isArray(data.favPartnerList)) {
      return {
        savedPartnerSiteIds: data.favPartnerList
          .map(savedPartner => savedPartner[appConstants.KEY_SITE_ID])
          .join(','),
        originalData: data.favPartnerList
      }
    }
    else {
      return null;
    }
  }
  else {
    return null;
  }
}

export default async function fetchUserSavedPartners(userId) {
  let fetchedDataObject =
    await fetchService(
      'fetchUserSavedPartners',
      SERVICE_URL,
      {
        ...appConstants.SERVICE_REQUEST_GET_USER_SAVED_PARTNERS_CONFIG,
        body: JSON.stringify({ ccoId: userId })
      }
    );
  return !fetchedDataObject.success ?
    {
      hasError: true,
      errorMessage: fetchedDataObject.statusMessage,
      savedPartners: null
    } :
    {
      hasError: false,
      errorMessage: null,
      ...processData(fetchedDataObject.data)
    };
}
